// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"822e6e9b","672":"5052bb30","696":"859cd729","824":"62df506f"}[chunkId] + ".chunk.css";
};